import * as angular from 'angular';
import { IRequestService } from '../request.service';
import { TriggerAction } from '../../models';

export interface ItriggerActionService {
    getAll(): angular.IPromise<TriggerAction[]>;
    getAll(force: boolean): angular.IPromise<TriggerAction[]>;
    addOne(triggerAction: TriggerAction): angular.IPromise<void>;
    updateOne(triggerAction: TriggerAction): angular.IPromise<TriggerAction>;
    deleteOne(triggerAction: TriggerAction): angular.IPromise<void>;
}

export class TriggerActionService implements ItriggerActionService {

    static serviceId = 'triggerActionService';
    static $inject = ['requestService'];

    private _controllerUrl = 'triggerAction';

    constructor(private _requestService: IRequestService) {
    }

    getAll(): angular.IPromise<TriggerAction[]>;
    getAll(force: boolean): angular.IPromise<TriggerAction[]>;
    getAll(force?: any) {
        if (force) {
            this._requestService.cleanCacheAtV1(this._controllerUrl);
        }
        return this._requestService.getAtV1(this._controllerUrl);
    }
    
    addOne(triggerAction: TriggerAction): angular.IPromise<void> {
        return this._requestService.postAtV1<TriggerAction>(`${this._controllerUrl}/add`, triggerAction)
            .then(data => {
                this._requestService.cleanCacheAtV1(this._controllerUrl);
            });
    }

    updateOne(triggerAction: TriggerAction): angular.IPromise<TriggerAction> {
        return this._requestService.postAtV1<TriggerAction>(`${this._controllerUrl}/update`, triggerAction)
            .then(data => {
                this._requestService.cleanCacheAtV1(this._controllerUrl);
                return data;
            });
    }

    deleteOne(triggerAction: TriggerAction): angular.IPromise<void> {
        return this._requestService.postAtV1<TriggerAction>(`${this._controllerUrl}/delete`, triggerAction)
            .then(data => {
                this._requestService.cleanCacheAtV1(this._controllerUrl);
            });
    }

}